import {ErrorMessage, useField} from 'formik'
import {ChangeEvent, FC, ReactNode} from 'react'

import {FormErrorMessage} from '../common/form/FormErrorMessage'
import {FormItem} from '../common/form/FormItem'
import {CheckboxInput} from './CheckboxInput'

type CheckboxProps = {
  name: string
  label: string | ReactNode | null
  isBoolean?: boolean
  textSize?: 'small' | 'medium'
  onChange?: (e: ChangeEvent) => void
  isDisabled?: boolean
  customIcon?: (isChecked: boolean, isDisabled: boolean) => ReactNode
}

export const Checkbox: FC<CheckboxProps> = ({
  name,
  label,
  isBoolean,
  textSize,
  onChange,
  isDisabled,
  customIcon,
}) => {
  const [field, , {setValue}] = useField<string | boolean>(name)

  const isChecked = isBoolean ? field.value === true : field.value === 'true'

  const handleChange = (e: ChangeEvent) => {
    if (!isDisabled) {
      onChange?.(e)
      setValue(isBoolean ? !isChecked : isChecked ? 'false' : 'true')
    }
  }

  return (
    <FormItem>
      <ErrorMessage name={name} render={(msg) => <FormErrorMessage message={msg} />} />
      <CheckboxInput
        label={label}
        isChecked={isChecked}
        onChange={handleChange}
        textSize={textSize}
        isDisabled={isDisabled}
        customIcon={customIcon}
      />
    </FormItem>
  )
}
